import useSWR, { SWRConfiguration } from "swr";
import { getTerminationReasons } from "@modules/accounts/api";
import { ITerminationReasons } from "@modules/accounts/interfaces/models/ITerminationReasons";
import { EServiceGroup } from "@pages/AccountDetails/interface/IAccountDetailsPage";

export const useGetTerminationReasons = (serviceGroup: EServiceGroup, options: SWRConfiguration = {}) =>
    useSWR<ITerminationReasons>(["getTerminationReasons", serviceGroup], {
        ...options,
        fetcher: () => getTerminationReasons(serviceGroup),
    });
